import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import util from '@/libs/util';
import axios from 'axios';
export default {
  data: function data() {
    return {
      fileList: [],
      fileLoading: false,
      dialogShow: false
    };
  },
  created: function created() {},
  methods: {
    open: function open() {
      this.fileList = [];
      this.dialogShow = true;
    },
    closeDialog: function closeDialog() {
      this.dialogShow = false;
    },
    handleExceed: function handleExceed() {
      this.$message.error(this.$t('onlyOneFileAllowed'));
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== file.uid;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 2;

      if (!isLt10M) {
        this.$message.error(this.$t('fileSizeLimit2MB'));
      }

      return isLt10M;
    },
    submitUpload: function submitUpload() {
      var _this = this;

      var fileList = this.fileList;

      if (fileList.length !== 1) {
        this.$message.warning(this.$t('pleaseSelectFile'));
        return;
      }

      this.fileLoading = true;
      var formData = new FormData();
      formData.append("file", fileList[0].raw);
      var reqFn = "/financial/pay_order_export_find";
      axios.post(process.env.VUE_APP_API + reqFn, formData, {
        headers: {
          "Content-Type": 'multipart/form-data',
          "Authorization": 'Bearer ' + (util.cookies.get('token') || ''),
          "Request-Url": this.$route.path
        },
        responseType: 'blob'
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var text, resJson, disposition, fileName, mimeType, extension, blob, url, link;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  console.log("res==", res);

                  if (!(res.status == 200)) {
                    _context.next = 25;
                    break;
                  }

                  if (!(res.data.type === 'application/json')) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 5;
                  return res.data.text();

                case 5:
                  text = _context.sent;

                  try {
                    resJson = JSON.parse(text);

                    _this.$message.error(resJson.message || resJson.msg || _this.$t('downloadFailed'));
                  } catch (e) {
                    _this.$message.error(_this.$t('downloadFailed'));
                  }

                  return _context.abrupt("return");

                case 8:
                  disposition = res.headers['content-disposition'];
                  fileName = '';
                  mimeType = res.data.type;
                  extension = '.zip'; // 默认后缀

                  if (mimeType.includes('excel') || mimeType.includes('spreadsheetml') || mimeType.includes('xls')) {
                    extension = '.xls';
                  } else if (mimeType.includes('csv')) {
                    extension = '.csv';
                  } else if (mimeType.includes('zip') || mimeType.includes('compressed')) {
                    extension = '.zip';
                  }

                  fileName = "".concat(_this.$t('sellTransactionMatchExport')).concat(extension);
                  blob = new Blob([res.data]);
                  url = window.URL.createObjectURL(blob);
                  link = document.createElement('a');
                  link.href = url;
                  link.download = fileName;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                  _context.next = 26;
                  break;

                case 25:
                  _this.$message.error(_this.$t('uploadFailed'));

                case 26:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).finally(function () {
        _this.fileLoading = false;
      });
    }
  }
};